import { useEffect } from 'react';
import { loadVersion } from '../api/versionService';

export function useAppVersionCheck({
  intervalMs = 30000,
  storageKey = 'app_version',
}: {
  intervalMs?: number;
  storageKey?: string;
} = {}) {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const latestVersion = await loadVersion();

        const currentVersion = localStorage.getItem(storageKey);

        if (currentVersion && latestVersion !== currentVersion) {
          console.warn(
            `[VersionCheck] Version changed: ${currentVersion} → ${latestVersion}`
          );

          // force reload site's code from the server
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace(window.location.href);
        }

        // Save latest version for future checks
        localStorage.setItem(storageKey, latestVersion);
      } catch (err) {
        console.warn('[VersionCheck] Failed to fetch version:', err);
      }
    };

    checkVersion(); // initial check
    const interval = setInterval(checkVersion, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs, storageKey]);
}
